import {TripCollection} from "../Trip";
import saline from "../../../assets/child/saline.jpg";

const dayChildSaline: TripCollection = {
    imageSrc: saline,
    trips: [
        {
            name: "12.1. Slănic Prahova I",
            route: "Braşov – Cheia – Vălenii de Munte – Slănic – Braşov",
            days: [
                [
                    {
                        locationName: "Mănăstirea Cheia",
                    },
                    {
                        locationName: "Casa Memorială Nicolae Iorga",
                    },
                    {
                        locationName: "Salina Slănic Prahova",
                    },
                ]
            ],
            notes: "Excursia oferă o combinație captivantă de spiritualitate, cultură și atracții naturale. Vizita începe la Mănăstirea Cheia, un lăcaș de cult renumit pentru liniștea și frumusețea sa, unde participanții se pot bucura de o atmosferă de reflecție și relaxare. Traseul continuă la Casa Memorială Nicolae Iorga din Vălenii de Munte, unde vizitatorii descoperă viața și activitatea unuia dintre cei mai importanți istorici și oameni de cultură români. Excursia se încheie la Salina Slănic Prahova, un loc impresionant care combină spectaculosul subteran cu funcțiuni recreative, oferind o experiență completă și memorabilă pentru toți participanții."
        },
        {
            name: "12.2. Slănic Prahova II",
            route: "Braşov – Posada – Câmpina – Slănic – Cheia – Braşov",
            days: [
                [
                    {
                        locationName: "Muzeul Cinegetic Posada",
                    },
                    {
                        locationName: "Casa Memorială Nicolae Grigorescu",
                    },
                    {
                        locationName: "Salina Slănic Prahova",
                    },
                    {
                        locationName: "Mănăstirea Cheia",
                    },
                ]
            ],
            notes: "Excursia propune o combinație fascinantă între natură, artă și spiritualitate. Prima oprire este la Muzeul Cinegetic Posada din Comarnic, unde vizitatorii descoperă fauna locală și tradițiile vânătorii. Urmează Casa Memorială Nicolae Grigorescu din Câmpina, ce oferă o incursiune în universul artistic al marelui pictor român. Traseul continuă la Salina Slănic Prahova, un spațiu subteran impresionant, perfect pentru recreere și explorare, și se încheie la Mănăstirea Cheia, lăcaș de cult renumit pentru atmosfera sa de liniște și spiritualitate. Excursia oferă o zi completă de descoperiri culturale, naturale și spirituale."
        },
        {
            name: "12.3. Târgu Ocna I",
            route: "Braşov – Târgu Ocna – Tescani – Oneşti – Braşov",
            days: [
                [
                    {
                        locationName: "Salina Târgu Ocna",
                    },
                    {
                        locationName: "Casa Memorială George Enescu – Tescani",
                    },
                    {
                        locationName: "Stejarul din Borzeşti",
                    },
                ]
            ],
            notes: "Excursia oferă o combinație captivantă între atracții naturale, culturale și istorice. Prima oprire este la Salina Târgu Ocna, un spațiu subteran impresionant, unde vizitatorii pot explora sălile și galeriile săpate în sare, bucurându-se de peisaje spectaculoase. Traseul continuă la Casa Memorială George Enescu din Tescani, unde viața și creația marelui compozitor român prind viață, oferind o experiență culturală deosebită. Excursia se încheie la Stejarul din Borzești, un monument natural impresionant, simbol al rezistenței și al tradițiilor locale, completând astfel o zi plină de descoperiri și momente memorabile."
        },
        {
            name: "12.4. Târgu Ocna II",
            route: "Braşov – Târgu Ocna – Braşov",
            days: [
                [
                    {
                        locationName: "Salina Târgu Ocna",
                    },
                    {
                        locationName: "Parcul Izvoarelor",
                    },
                    {
                        locationName: "Mănăstirea Măgura",
                    },
                ]
            ],
            notes: "Excursia propune o zi dedicată explorării atracțiilor naturale și spirituale ale zonei Târgu Ocna. Prima oprire este la Salina Târgu Ocna, un spațiu subteran impresionant, unde vizitatorii pot admira galeriile săpate în sare și peisajele spectaculoase. Traseul continuă la Parcul Izvoarelor, un cadru natural plăcut, ideal pentru plimbări și relaxare, și se încheie la Mănăstirea Măgura, un lăcaș de cult ce impresionează prin liniște, spiritualitate și frumusețea arhitecturii. Excursia oferă o experiență completă, combinând natura, cultura și spiritualitatea."
        },
        {
            name: "12.5. Turda",
            route: "Braşov – Turda – Sighişoara – Braşov",
            days: [
                [
                    {
                        locationName: "Salina Turda",
                    },
                    {
                        locationName: "Tur Centru Istoric Sighişoara",
                    },
                ]
            ],
            notes: "Excursia propune o combinație impresionantă între atracțiile naturale și patrimoniul istoric al Transilvaniei. Prima oprire este la Salina Turda, un spațiu subteran spectaculos, ce oferă vizitatorilor o experiență unică prin sălile sale vaste și instalațiile moderne. Traseul continuă la Sighișoara, cu un tur al centrului istoric, unde străduțele medievale și clădirile păstrează atmosfera autentică a orașului natal al lui Vlad Țepeș. Excursia oferă astfel o zi completă de descoperiri, îmbinând natura, istoria și cultura într-un mod captivant."
        },
    ]
}

export default dayChildSaline;